export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14809.f0ab7e5e.jpg";